export function getYears() {
  let loopYear = new Date().getFullYear();
  let month = new Date().getMonth();

  if (month < 7) {
    loopYear = loopYear - 1;
  }
  const years = [];
  const startYear = 2018;

  while (loopYear >= startYear) {
    years.push(loopYear);
    loopYear -= 1;
  }

  return years;
}

/**
 * Fetches list of weeks (just number and URL ref).
 */
async function fetchWeeksList(year) {
  const resp = await fetch(
    `https://sports.core.api.espn.com/v2/sports/football/leagues/nfl/seasons/${year}/types/2/weeks`
  );
  if (!resp.ok) return [];
  const json = await resp.json();
  return json.items.map(w => {
    const url = w.$ref;
    const parts = url.split('/');
    const weekNum = parseInt(parts[parts.length - 1], 10);
    return { week: weekNum, url: url.replace('http://', 'https://') };
  });
}

/**
 * Fetch week detail including startDate.
 */
async function fetchWeekDetail(weekUrl) {
  const resp = await fetch(weekUrl);
  if (!resp.ok) return null;
  const json = await resp.json();
  return {
    week: json.number,
    startDate: new Date(json.startDate),
    endDate: new Date(json.endDate),
  };
}

export async function getMostRecentNFLSeasonAndWeek() {
  const now = new Date();
  const currentYear = now.getFullYear();

  async function findLastWeekInSeason(year) {
    const weeks = await fetchWeeksList(year);
    if (!weeks.length) return null;

    const details = await Promise.all(
      weeks.map(w => fetchWeekDetail(w.url))
    );

    // Filter to weeks whose startDate has passed
    const startedWeeks = details.filter(
      d => d && d.startDate <= now
    );
    if (!startedWeeks.length) return null;

    // Get the one with the maximum week number
    const last = startedWeeks.reduce((a, b) =>
      b.week > a.week ? b : a
    );
    return { season: year, week: last.week };
  }

  let result = await findLastWeekInSeason(currentYear);
  if (!result) {
    result = await findLastWeekInSeason(currentYear - 1);
  }
  return result;
}

